import { Chip, emptyFragment, Typography } from '@execonline-inc/execonline-ui';
import { nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import Currency from './Currency';

function ExperiencePrice() {
  return nothing()
    .map(() => (
      <Chip variant="solid" radius="full" size="lg" className="justify-center bg-card px-3 py-2">
        <Typography
          className="text-foreground"
          variant="bodyMedium"
          as="span"
          fontWeight="semibold"
        >
          <Currency priceInDollars={0} />
        </Typography>
      </Chip>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ExperiencePrice);
